import { render, staticRenderFns } from "./EmailSetting.vue?vue&type=template&id=d8fb4a06"
import script from "./EmailSetting.vue?vue&type=script&lang=js"
export * from "./EmailSetting.vue?vue&type=script&lang=js"
import style0 from "./EmailSetting.vue?vue&type=style&index=0&id=d8fb4a06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports